import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface DashboardSlice {
  selectedBls:any[]
}

const initialState: DashboardSlice = {
  selectedBls:[]
};

export const blSlice = createSlice({
  name: 'blSlice',
  initialState,
  reducers: {
    updateSelctedBls: (state, action: PayloadAction<any[]>) => {
      state.selectedBls = action.payload;
    }

  },
  extraReducers: (builder) => {

  },
});

export const {
updateSelctedBls
} = blSlice.actions;

export default blSlice.reducer;
